import interact from "interactjs"
import { setSsObj } from "./storage"

function preventScroll(e) {
  e.preventDefault()
}

function disableScroll() {
  // Disable scrolling on body
  document.body.style.overflow = "hidden"
  // Prevent touch events from scrolling on mobile
  document.addEventListener("touchmove", preventScroll, { passive: false })
  document.addEventListener("wheel", preventScroll, { passive: false })
}

function enableScroll() {
  // Re-enable scrolling
  document.body.style.overflow = ""

  // Remove touch event listeners
  document.removeEventListener("touchmove", preventScroll)
  document.removeEventListener("wheel", preventScroll)
}

function dragMoveListener(event) {
  var target = event.target.parentNode
  // keep the dragged position in the data-x/data-y attributes
  var x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx
  var y = (parseFloat(target.getAttribute("data-y")) || 0) + event.dy
  target.style.transform = "translate(" + x + "px, " + y + "px)"
  target.setAttribute("data-x", x)
  target.setAttribute("data-y", y)
}

export function registerDrag(el) {
  interact(el).draggable({
    inertia: true,
    modifiers: [
      interact.modifiers.restrictRect({
        restriction: "body",
        endOnly: true,
      }),
    ],
    autoScroll: true,
    listeners: {
      start() {
        // Disable page scrolling when drag starts (mobile-friendly)
        disableScroll()
      },
      move: dragMoveListener,
      end(event) {
        // Re-enable page scrolling when drag ends
        enableScroll()
        setSsObj("video-player-position", {
          x: event.target.parentNode.getAttribute("data-x") || 0,
          y: event.target.parentNode.getAttribute("data-y") || 0,
        })
      },
    },
  })

  window.dragMoveListener = dragMoveListener
}
